import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from '../../../../../../components/Dropdown/Dropdown';
import { Placement } from '../../../../../../components/ToolTip/IToolTip';
import ToolTip from '../../../../../../components/ToolTip/ToolTip';
import { useAppSelector } from '../../../../../../reduxService/hooks';
import { conversionLabel } from '../../../../../conversion';
import { selectProjectInfo } from '../../../../../store/projectInfo/projectInfoSlice';
import { IMaterialDataDropdownsProps } from './IMaterialDataDropdowns';
import './MaterialDataDropdowns.scss';

const MaterialDataDropdowns = (props: IMaterialDataDropdownsProps) => {
    const { t } = useTranslation();
    const projectInfo = useAppSelector(selectProjectInfo);

    return (
        <div className='d-flex justify-content-between gap-2 MaterialDataDropdowns'>
            {!!props.optionsThickness && (
                <Dropdown
                    title={t('material_thickness_measure', { unit_measure: conversionLabel.m_in[projectInfo.data?.unitOfMeasure as number] })}
                    name='thickness'
                    className='dropdown'
                    defaultValue={props.defaultThickness}
                    options={props.optionsThickness}
                    onChange={props.onChange}
                />
            )}
            {!!props.optionsRock && (
                <Dropdown
                    title={t('material_rock', { unit_measure: conversionLabel.m_in[projectInfo.data?.unitOfMeasure as number] })}
                    name='rockD50'
                    className='dropdown'
                    defaultValue={props.defaultRock}
                    options={props.optionsRock}
                    onChange={props.onChange}
                />
            )}
            {!!props.optionsCu && (
                <div className='cuDiv'>
                    <Dropdown title={t('material_cu')} name='cu' className='dropdown' defaultValue={props.defaultCu} options={props.optionsCu} onChange={props.onChange} />
                    <ToolTip
                        title={
                            <>
                                <h5>{t('material_cu')}</h5>
                                {t('material_cu')}
                                <em> {t('cu_description')}</em>
                            </>
                        }
                        placement={Placement.top}>
                        <i className='fa-sharp fa-solid fa-circle-info fs-5 p-2 align-self-end' />
                    </ToolTip>
                </div>
            )}
        </div>
    );
};

export default MaterialDataDropdowns;
